import { render, staticRenderFns } from "./rating-select.vue?vue&type=template&id=108fe267"
import script from "./rating-select.vue?vue&type=script&lang=js"
export * from "./rating-select.vue?vue&type=script&lang=js"
import style0 from "./rating-select.vue?vue&type=style&index=0&id=108fe267&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports